export const SMART_PROFILES_ENABLED = process.env.REACT_APP_SMART_PROFILES === 'true';
const enabledCardIds = new Set((process.env.REACT_APP_SMART_PROFILE_IDS || '').split(',').map(id => id.trim()).filter(Boolean));
export const isSmartCard = (id, type) => SMART_PROFILES_ENABLED && type === 'smart' &&
  Boolean(id) && (!enabledCardIds.size || enabledCardIds.has(id));
export const THEMES = [
  // Keep saved theme IDs stable while aligning their appearance with the existing site.
  { id: 'linen', name: 'Smart Stand', note: 'Blue and white', colors: ['#ffffff', '#172b4d', '#1976d2'] },
  { id: 'forest', name: 'Graphite', note: 'White with charcoal buttons', colors: ['#ffffff', '#202124', '#3c4043'] },
  { id: 'clay', name: 'Light', note: 'Light gray with blue accents', colors: ['#f5f7fa', '#172b4d', '#1976d2'] },
  { id: 'midnight', name: 'Dark', note: 'Dark gray with blue accents', colors: ['#151a21', '#f1f5f9', '#90caf9'] },
];
export const MODES = [
  ['profile', 'Profile page', 'Build your page, one section at a time.'],
  ['link', 'Any website', 'Send visitors straight to a website.'],
  ['contact', 'Contact card', 'Let people save your contact details.'],
  ['phone', 'Phone call', 'Make it easy to call your business.'],
  ['sms', 'Text message', 'Start a conversation by text.'],
  ['email', 'Email', 'Open a ready-to-address email.'],
  ['maps', 'Directions', 'Help people find you.'],
  ['payment', 'Payment link', 'Open your existing checkout.'],
  ['google-review', 'Google reviews', 'Invite an honest customer review.'],
  ['wallet', 'Wallet pass', 'Share an Apple or Google Wallet pass.'],
];
export const BLOCK_TYPES = [
  ['link', 'Link', 'A website, menu, or social profile', '↗'],
  ['contact', 'Save contact', 'Your details in their address book', '＋'],
  ['booking', 'Booking', 'Your existing appointment page', '▦'],
  ['phone', 'Call', 'An easy way to get in touch', '↗'],
  ['sms', 'Message', 'Start a text conversation', '↗'],
  ['email', 'Email', 'Address, subject, and message', '✉'],
  ['maps', 'Directions', 'Your place on the map', '⌖'],
  ['payment', 'Payment', 'Your hosted checkout or payment page', '↗'],
  ['review', 'Google review', 'A direct invitation to leave feedback', '☆'],
  ['text', 'Text', 'Tell your story in your own words', 'T'],
  ['image', 'Image', 'A photo, portfolio piece, or announcement', '▧'],
  ['divider', 'Divider', 'Separate sections', '—'],
  ['wallet', 'Wallet', 'A pass people can keep on their phone', '▣'],
  ['inquiry', 'Contact form', 'Collect a message in your private inbox', '✉'],
];
export const uid = () => window.crypto?.randomUUID?.() || `b-${Date.now()}-${Math.random().toString(36).slice(2)}`;
export function makeBlock(type) {
  return { id: uid(), type, enabled: true, label: ({
    link: 'Visit my website', contact: 'Save my contact', booking: 'Book an appointment',
    phone: 'Give me a call', sms: 'Send a message', email: 'Email me',
    maps: 'Get directions', payment: 'Pay online', review: 'Leave a review', wallet: 'Keep in your wallet', inquiry: 'Let’s talk',
  })[type] || '', description: '', url: '', text: '', image: '', alt: '' };
}
export function moveBlock(blocks, from, to) {
  if (from < 0 || to < 0 || from >= blocks.length || to >= blocks.length) return blocks;
  const result = [...blocks], [item] = result.splice(from, 1);
  result.splice(to, 0, item);
  return result;
}
export const safeWebUrl = value => {
  try { const u = new URL(value); return ['https:', 'http:'].includes(u.protocol) && !u.username && !u.password ? u.href : ''; }
  catch { return ''; }
};
export const safeImage = value => /^data:image\/(?:png|jpeg|webp);base64,[a-zA-Z0-9+/]+=*$/.test(value || '') ? value : safeWebUrl(value);
export function getActionUrl(block, identity = {}, userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent) {
  const number = (block.phone || identity.phone || '').replace(/[^\d+]/g, '');
  switch (block.type) {
    case 'link': case 'booking': case 'payment': return safeWebUrl(block.url);
    case 'phone': return number ? `tel:${number}` : '';
    case 'sms': {
      const separator = /iPhone|iPad|iPod/i.test(userAgent) ? '&' : '?';
      return number ? `sms:${number}${block.message ? `${separator}body=${encodeURIComponent(block.message)}` : ''}` : '';
    }
    case 'email': {
      const email = block.email || identity.email;
      return email && /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(email)
        ? `mailto:${encodeURIComponent(email).replace(/%40/g, '@')}?subject=${encodeURIComponent(block.subject || '')}&body=${encodeURIComponent((block.message || '').replace(/\r\n|\r|\n/g, '\r\n'))}` : '';
    }
    case 'maps': return block.address || identity.address
      ? `https://www.google.com/maps/search/?${new URLSearchParams({ api: '1', query: block.address || identity.address })}` : '';
    case 'review': case 'google-review': return block.placeId
      ? `https://search.google.com/local/writereview?placeid=${encodeURIComponent(block.placeId)}` : safeWebUrl(block.url);
    default: return '';
  }
}
export function configPath(id, type) {
  return isSmartCard(id, type)
    ? `/studio/activate?id=${encodeURIComponent(id)}`
    : `/google-review-config?id=${encodeURIComponent(id)}&t=${encodeURIComponent(type)}`;
}
